import React, { useEffect, useMemo, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import swal from "sweetalert";
import { PulseLoader } from "react-spinners";
import { APIMS } from "../../../../../../config/apims";

export default function ModalTglRapor({
  show,
  onHide,

  selectedSemesterId,
  selectedSemesterName,
  selectedSemesterNumber,

  branch,
  level,
  schoolId,
}) {
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("id_admin")?.replace(/[|&;$%@"<>()+,]/g, "");
  const ascending = 1;

  const [form, setForm] = useState({
    id: "",
    ysb_semester_id: "",
    ysb_branch_id: "",
    level: "",
    ysb_school_id: "",
    print_date: "",
    user_id: "",
  });

  const [loadingData, setLoadingData] = useState(false);
  const [saving, setSaving] = useState(false);

  // true = form bisa diedit
  // false = form disable
  const [isEditMode, setIsEditMode] = useState(true);

  // penanda data sudah pernah tersimpan atau belum
  const [hasExistingData, setHasExistingData] = useState(false);

  const headers = useMemo(
    () => ({
      Authorization: `${token}`,
      "Content-Type": "application/json",
    }),
    [token]
  );

  const semesterLabel = useMemo(() => {
    if (!selectedSemesterName && !selectedSemesterNumber) return "-";
    return `${selectedSemesterName || ""} (Semester ${selectedSemesterNumber || ""})`;
  }, [selectedSemesterName, selectedSemesterNumber]);

  const basePayload = useMemo(
    () => ({
      ysb_semester_id: selectedSemesterId || "",
      ysb_branch_id: branch || "",
      level: level || "",
      ysb_school_id: schoolId || "",
      user_id: userId || "",
    }),
    [selectedSemesterId, branch, level, schoolId, userId]
  );

  useEffect(() => {
    if (!show) return;

    fetchExistingData();
  }, [show, selectedSemesterId, branch, level, schoolId]);

  const fetchExistingData = async () => {
    if (!selectedSemesterId || !branch || !schoolId) {
      setForm({
        id: "",
        ...basePayload,
        print_date: "",
      });
      setHasExistingData(false);
      setIsEditMode(true);
      return;
    }

    setLoadingData(true);

    try {
      // const response = await APIMS.get("/api/titimangsa-rapots?page=1&limit=1000&ascending=true&search=", {
      //   headers,
      //   params: {
      //     ysb_semester_id: selectedSemesterId,
      //     ysb_branch_id: branch,
      //     level: level,
      //     ysb_school_id: schoolId,
      //   },
      // });
      const response = await APIMS.get("/api/titimangsa-rapots", {
        headers,
        params: {
          page: 1,
          limit: 1000,
          ascending: 0,
          search: "",
          ysb_semester_id: selectedSemesterId,
          ysb_branch_id: branch,
          level: level,
          ysb_school_id: schoolId,
        },
      });

      const dataRaw = response?.data?.data;

      const data = Array.isArray(dataRaw) ? dataRaw[0] : dataRaw;

      if (data && data.print_date) {
        setForm({
          id: data?.id || "",
          ysb_semester_id: data?.ysb_semester_id || selectedSemesterId || "",
          ysb_branch_id: data?.ysb_branch_id || branch || "",
          level: data?.level || level || "",
          ysb_school_id: data?.ysb_school_id || schoolId || "",
          print_date: data?.print_date || "",
          user_id: data?.user_id || userId || "",
        });

        // kalau data sudah ada, form langsung disable
        setHasExistingData(true);
        setIsEditMode(false);
      } else {
        // kalau belum pernah input, form kosong dan aktif
        setForm({
          id: "",
          ...basePayload,
          print_date: "",
        });

        setHasExistingData(false);
        setIsEditMode(true);
      }
    } catch (error) {
      // kalau API GET 404 / data tidak ditemukan, tetap buka form kosong
      if (error?.response?.status === 404) {
        setForm({
          id: "",
          ...basePayload,
          print_date: "",
        });

        setHasExistingData(false);
        setIsEditMode(true);
        return;
      }

      swal({
        title: "Gagal",
        text:
          error?.response?.data?.message ||
          "Gagal mengambil data tanggal rapor.",
        icon: "error",
      });

      setForm({
        id: "",
        ...basePayload,
        print_date: "",
      });

      setHasExistingData(false);
      setIsEditMode(true);
    } finally {
      setLoadingData(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEdit = () => {
    setIsEditMode(true);
  };

  const handleSave = async () => {
    if (!form.ysb_semester_id) {
      swal({
        title: "Semester belum dipilih",
        text: "Silakan pilih semester terlebih dahulu.",
        icon: "warning",
      });
      return;
    }

    if (!form.print_date) {
      swal({
        title: "Tanggal belum diisi",
        text: "Silakan isi tanggal rapor terlebih dahulu.",
        icon: "warning",
      });
      return;
    }

    setSaving(true);

    try {
      const payload = {
        ysb_semester_id: form.ysb_semester_id,
        ysb_branch_id: form.ysb_branch_id,
        level: form.level,
        ysb_school_id: form.ysb_school_id,
        print_date: form.print_date,
        user_id: userId,
      };

      const response = await APIMS.post(
        "/api/titimangsa-rapots/store",
        payload,
        { headers }
      );

      if (response?.status === 200 || response?.status === 201) {
        swal({
          title: "Berhasil",
          text: hasExistingData
            ? "Tanggal rapor berhasil diperbarui."
            : "Tanggal rapor berhasil disimpan.",
          icon: "success",
        });

        // setelah save modal langsung tertutup
        onHide();
      }
    } catch (error) {
      swal({
        title: "Gagal",
        text:
          error?.response?.data?.message ||
          "Tanggal rapor gagal disimpan.",
        icon: "error",
      });
    } finally {
      setSaving(false);
    }
  };

  // const inputDisabled = loadingData || saving || !isEditMode;
  const inputDisabled =   !isEditMode || isEditMode;

  return (
    <Modal isOpen={show} toggle={onHide} centered size="md">
      <ModalHeader toggle={onHide}>
        Cetak Tanggal Rapor
      </ModalHeader>

      <ModalBody>
        {loadingData ? (
          <div
            className="text-center"
            style={{
              padding: "35px 0",
            }}
          >
            <PulseLoader color="#3f5bea" size={10} />
            <div
              style={{
                marginTop: "12px",
                color: "#3f5bea",
                fontSize: "13px",
                fontWeight: 500,
              }}
            >
              Memuat data tanggal rapor...
            </div>
          </div>
        ) : (
          <>
            <div className="mb-3 mt-3">
              <label
                style={{
                  fontSize: "13px",
                  fontWeight: 600,
                  marginBottom: "6px",
                  display: "block",
                }}
              >
                Semester
              </label>

              <input
                type="text"
                className="form-control"
                value={semesterLabel}
                disabled
                style={{
                  borderRadius: "10px",
                  backgroundColor: "#f3f4f6",
                  fontSize: "14px",
                }}
              />
            </div>

            <div className="mb-3">
              <label
                style={{
                  fontSize: "13px",
                  fontWeight: 600,
                  marginBottom: "6px",
                  display: "block",
                }}
              >
                Tanggal Cetak Rapor
              </label>

              <input
                type="date"
                name="print_date"
                className="form-control"
                value={form.print_date}
                onChange={handleChange}
                disabled={inputDisabled}
                style={{
                  borderRadius: "10px",
                  backgroundColor: inputDisabled ? "#f3f4f6" : "#fff",
                  fontSize: "14px",
                }}
              />
            </div>

            {hasExistingData && !isEditMode && (
              <div
                style={{
                  backgroundColor: "#f8fafc",
                  border: "1px solid #e5e7eb",
                  borderRadius: "10px",
                  padding: "10px 12px",
                  fontSize: "12px",
                  color: "#64748b",
                }}
              >
                <b style={{color: "#034196",}}> Tanggal cetak rapor semester ini sudah diisi oleh Kepala Sekolah. </b>
              </div>
            )}

            {!hasExistingData && (
              <div
                style={{
                  backgroundColor: "#fff7ed",
                  border: "1px solid #fed7aa",
                  borderRadius: "10px",
                  padding: "10px 12px",
                  fontSize: "12px",
                  color: "#9a3412",
                }}
              >
                Tanggal cetak rapor untuk semester ini
                belum diisi oleh Kepala Sekolah. Mohon hubungi Kepala Sekolah untuk mengisi tanggal cetak rapor.
              </div>
            )}
          </>
        )}
      </ModalBody>

      {/* <ModalFooter>
        <button
          type="button"
          onClick={onHide}
          disabled={saving}
          style={{
            border: "none",
            borderRadius: "10px",
            padding: "9px 16px",
            backgroundColor: "#e5e7eb",
            color: "#111827",
            fontSize: "13px",
            cursor: saving ? "not-allowed" : "pointer",
          }}
        >
          Tutup
        </button>

        {!loadingData && hasExistingData && !isEditMode && (
          <button
            type="button"
            onClick={handleEdit}
            disabled={saving}
            style={{
              border: "none",
              borderRadius: "10px",
              padding: "9px 16px",
              backgroundColor: "#2563eb",
              color: "#fff",
              fontSize: "13px",
              cursor: saving ? "not-allowed" : "pointer",
            }}
          >
            Edit
          </button>
        )}

        {!loadingData && isEditMode && (
          <button
            type="button"
            onClick={handleSave}
            disabled={saving}
            style={{
              border: "none",
              borderRadius: "10px",
              padding: "9px 16px",
              backgroundColor: saving ? "#c9c9c9" : "rgb(241, 145, 0)",
              color: "#fff",
              fontSize: "13px",
              minWidth: "90px",
              cursor: saving ? "not-allowed" : "pointer",
            }}
          >
            {saving ? <PulseLoader color="#fff" size={6} /> : "Simpan"}
          </button>
        )}
      </ModalFooter> */}
    </Modal>
  );
}